module.exports = __webpack_public_path__ + "img/gena-skate.b3984b42.svg";